import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-inactive-dormand',
  templateUrl: './inactive-dormand.component.html',
  styleUrls: ['./inactive-dormand.component.css']
})
export class InactiveDormandComponent implements OnInit {
  title = "Inactive/Dormand";
  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/accountmaster/inactive-dormand/inactive-dormand.component.ts